import { useMutation, useQueryClient } from 'react-query'

import { v1UserQueries } from '@webapp/platform/iam/query-configs/v1UserQueries'
import { type SlackIntegrationError } from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import { slackIntegrationRepository } from '@webapp/platform/integrations/data-access/repositories/SlackIntegrationRepository'
import { slackIntegrationQueries } from '@webapp/platform/integrations/query-configs/slackIntegrationQueries'

interface LinkUserVariables {
  procurifyUserId: number
  slackUserId: string
}

export const useLinkSlackUserModel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, SlackIntegrationError, LinkUserVariables>({
    mutationFn: ({ procurifyUserId, slackUserId }: LinkUserVariables) => {
      return slackIntegrationRepository.linkUser(procurifyUserId, slackUserId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: v1UserQueries.activeUsers().queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: slackIntegrationQueries.slackUsers().queryKey,
      })
    },
  })

  return {
    linkUser: mutation.mutateAsync,
    isLinking: mutation.isLoading,
  }
}
